// Data Jadwal Perkuliahan
export const dataJadwal = [
    // Jadwal Teknik Informatika Semester Ganjil 2024/2025
    {
        jadwal_id: 1,
        mk_id: 33, // Metodologi Penelitian
        kode_mk: "TI701",
        nama_mk: "Metodologi Penelitian",
        sks: 2,
        kelas: "A",
        dosen_id: "DSN001",
        dosen_nama: "Dr. Citra Dewi, S.Kom., M.Cs.",
        hari_id: 1,
        hari: "Senin",
        jam_mulai: "07:00",
        jam_selesai: "08:40",
        ruangan_id: 1,
        ruangan: "R.101",
        prodi_id: 1,
        semester: 7,
        tahun_akademik: "2024/2025",
        kapasitas: 40,
        terisi: 35
    },
    {
        jadwal_id: 2,
        mk_id: 34, // Deep Learning
        kode_mk: "TI702",
        nama_mk: "Deep Learning",
        sks: 3,
        kelas: "A",
        dosen_id: "DSN001",
        dosen_nama: "Dr. Citra Dewi, S.Kom., M.Cs.",
        hari_id: 2,
        hari: "Selasa",
        jam_mulai: "08:40",
        jam_selesai: "11:10",
        ruangan_id: 6,
        ruangan: "Lab Komputer 1",
        prodi_id: 1,
        semester: 7,
        tahun_akademik: "2024/2025",
        kapasitas: 30,
        terisi: 28
    },
    {
        jadwal_id: 3,
        mk_id: 35, // Blockchain
        kode_mk: "TI703",
        nama_mk: "Blockchain",
        sks: 3,
        kelas: "A",
        dosen_id: "DSN009",
        dosen_nama: "Joko Santoso, S.Kom., M.T.",
        hari_id: 3,
        hari: "Rabu",
        jam_mulai: "13:20",
        jam_selesai: "15:50",
        ruangan_id: 7,
        ruangan: "Lab Komputer 2",
        prodi_id: 1,
        semester: 7,
        tahun_akademik: "2024/2025",
        kapasitas: 30,
        terisi: 25
    },
    {
        jadwal_id: 4,
        mk_id: 36, // Cyber Security
        kode_mk: "TI704",
        nama_mk: "Cyber Security",
        sks: 3,
        kelas: "A",
        dosen_id: "DSN009",
        dosen_nama: "Joko Santoso, S.Kom., M.T.",
        hari_id: 4,
        hari: "Kamis",
        jam_mulai: "07:00",
        jam_selesai: "09:30",
        ruangan_id: 8,
        ruangan: "Lab Jaringan",
        prodi_id: 1,
        semester: 7,
        tahun_akademik: "2024/2025",
        kapasitas: 25,
        terisi: 22
    },
    {
        jadwal_id: 5,
        mk_id: 23, // Data Mining - Semester 5
        kode_mk: "TI501",
        nama_mk: "Data Mining",
        sks: 3,
        kelas: "A",
        dosen_id: "DSN001",
        dosen_nama: "Dr. Citra Dewi, S.Kom., M.Cs.",
        hari_id: 1,
        hari: "Senin",
        jam_mulai: "09:30",
        jam_selesai: "12:00",
        ruangan_id: 6,
        ruangan: "Lab Komputer 1",
        prodi_id: 1,
        semester: 5,
        tahun_akademik: "2024/2025",
        kapasitas: 30,
        terisi: 30
    },
    {
        jadwal_id: 6,
        mk_id: 24, // Cloud Computing
        kode_mk: "TI502",
        nama_mk: "Cloud Computing",
        sks: 3,
        kelas: "A",
        dosen_id: "DSN009",
        dosen_nama: "Joko Santoso, S.Kom., M.T.",
        hari_id: 2,
        hari: "Selasa",
        jam_mulai: "13:20",
        jam_selesai: "15:50",
        ruangan_id: 7,
        ruangan: "Lab Komputer 2",
        prodi_id: 1,
        semester: 5,
        tahun_akademik: "2024/2025",
        kapasitas: 30,
        terisi: 28
    },
    {
        jadwal_id: 7,
        mk_id: 18, // Pemrograman Web - Semester 4
        kode_mk: "TI401",
        nama_mk: "Pemrograman Web",
        sks: 3,
        kelas: "A",
        dosen_id: "DSN008",
        dosen_nama: "Indah Kusuma, S.Kom., M.Kom.",
        hari_id: 3,
        hari: "Rabu",
        jam_mulai: "07:00",
        jam_selesai: "09:30",
        ruangan_id: 6,
        ruangan: "Lab Komputer 1",
        prodi_id: 1,
        semester: 4,
        tahun_akademik: "2024/2025",
        kapasitas: 30,
        terisi: 30
    },
    {
        jadwal_id: 8,
        mk_id: 19, // Pemrograman Mobile
        kode_mk: "TI402",
        nama_mk: "Pemrograman Mobile",
        sks: 3,
        kelas: "A",
        dosen_id: "DSN008",
        dosen_nama: "Indah Kusuma, S.Kom., M.Kom.",
        hari_id: 4,
        hari: "Kamis",
        jam_mulai: "09:30",
        jam_selesai: "12:00",
        ruangan_id: 7,
        ruangan: "Lab Komputer 2",
        prodi_id: 1,
        semester: 4,
        tahun_akademik: "2024/2025",
        kapasitas: 30,
        terisi: 29
    },
    // Jadwal Sistem Informasi
    {
        jadwal_id: 9,
        mk_id: 40, // ERP
        kode_mk: "SI103",
        nama_mk: "Enterprise Resource Planning",
        sks: 3,
        kelas: "A",
        dosen_id: "DSN003",
        dosen_nama: "Ir. Dedi Hartono, M.Kom.",
        hari_id: 5,
        hari: "Jumat",
        jam_mulai: "07:00",
        jam_selesai: "09:30",
        ruangan_id: 2,
        ruangan: "R.102",
        prodi_id: 2,
        semester: 3,
        tahun_akademik: "2024/2025",
        kapasitas: 40,
        terisi: 35
    },
    // Jadwal Teknik Mesin
    {
        jadwal_id: 10,
        mk_id: 42, // Termodinamika
        kode_mk: "TM102",
        nama_mk: "Termodinamika",
        sks: 3,
        kelas: "A",
        dosen_id: "DSN004",
        dosen_nama: "Dr. Eko Prasetyo, S.T., M.T.",
        hari_id: 1,
        hari: "Senin",
        jam_mulai: "13:20",
        jam_selesai: "15:50",
        ruangan_id: 3,
        ruangan: "R.103",
        prodi_id: 3,
        semester: 2,
        tahun_akademik: "2024/2025",
        kapasitas: 35,
        terisi: 32
    }
];

// Get jadwal by dosen
export const getJadwalByDosen = (dosen_id) => {
    return dataJadwal.filter(j => j.dosen_id === dosen_id);
};

// Get jadwal by prodi
export const getJadwalByProdi = (prodi_id) => {
    return dataJadwal.filter(j => j.prodi_id === prodi_id);
};

// Get jadwal by hari
export const getJadwalByHari = (hari_id) => {
    return dataJadwal.filter(j => j.hari_id === hari_id);
};

export default dataJadwal;
